<template>
    <div :id="id" class="circle-progress">
        <svg id="Spinner" x="0px" y="0px" width="400px" height="320px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
            <g>
                <g id="Spinner-Container">
                    <g id="Ticks-Unsed-Container"></g>
                    <g id="Tick-Used-Container"></g>
                </g>
                <circle id="Spinner-Line-Bold" fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" :stroke="themeObj.strokeColor" stroke-width="13" cx="250" cy="250" r="195"></circle>
                <circle id="Spinner-Line-Thin" fill="none" stroke="#D6D6D6" stroke-width="4" cx="250" cy="250" r="170"></circle>

                <g id="Progress-Content" class="progress-content" transform="translate(140,250)">
                    <text class="percentage" :fill="themeObj.textColor">{{percentageProgress}}%</text>
                    <g v-if="label">
                        <text dx="0" dy="40" class="label">{{label}}</text>
                        <rect x="0" y="55" width="90" height="8" class="line" fill="#E4030B"></rect>
                    </g>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>

    import {TweenMax, TimelineMax} from 'gsap';
    import * as d3 from "d3";

    export default {
        name: 'SvgCircleProgress',
        props: {
            label: {
                type: String,
                requred: true
            },
            percentage: {
                type: [Number, String],
                default: 0
            },
            id: {
                type: [Number, String],
                default : 'CircleProgress'
            },
            theme: {
                type: String,
                default: 'light'
            },
            pause: {
                type: [String, Boolean],
                default: false
            }
        },
        data: () => ({

            svg: null,
            originX : 500,
            originY : 500,
            circleRadius: 220,

            tl: null,
            circleProgress: null,

            spinner: null,
            spinnerContainer: null,

            spinnerLineThin: null,
            spinnerLineBold: null,

            ProgressContent: null,

            ticks : null,
            ticksRed : null,

            percentageObj : {
                value: 0
            },

            length : 120,
            animated : false

        }),
        computed: {
            parsePercentage(){
                return Math.min(Math.abs(this.percentage), 100)
            },
            percentageProgress(){
                return this.percentageObj.value.toFixed(0);
            },
            themeObj(){
                let obj = {
                    strokeColor : '#eeeeee',
                    textColor : "#E4030B"
                };
                //
                switch(this.theme) {
                    case 'light':
                        // default
                        break;
                    case 'dark':
                        obj =  {
                            strokeColor : '#000000',
                            textColor : "#000000"
                        };
                        break;
                }

                return obj;
            }
        },
        watch:{
            'percentageObj.value'(){
                if(!this.tlTicksUnsed) return;
                this.tlTicksUnsed.progress( (this.percentageProgress / 100) );
            },
            'percentage'(){
                this.setPercent(this.parsePercentage);
            },
            'theme'(){

            }
        },
        methods: {

            setPercent(new_value){
                if(!this.tlTicksUnsed) return
                TweenMax.to(this.percentageObj, 1.35 , { value:new_value, ease:Power2.easeOut,
//                    onUpdate:() => {
//                        this.tlTicksUnsed.progress( (this.percentageProgress / 100) );
//                    }
                });
            },

            animateCompleteHandler() {
//                console.log('animateCompleteHandler')
            },

            init(){
                this.circleProgress = this.$el ;

                // SVG
                this.spinner = this.circleProgress.querySelector('#Spinner');

                this.spinnerLineBold = this.circleProgress.querySelector('#Spinner-Line-Bold');
                this.spinnerLineThin = this.circleProgress.querySelector('#Spinner-Line-Thin');

                this.spinnerContainer = this.circleProgress.querySelector('#Spinner-Container');

                this.ProgressContent = this.spinner.querySelector('#Progress-Content');

                // SVG dynamic
                this.ticks = this.spinner.querySelector('#Ticks');
                this.ticksRed = this.spinner.querySelector('#TicksRed');

            },

            createsTicks(){

                let svgSpinner = d3.select('#'+this.id+' #Spinner-Container');

                let originX = 250;
                let originY = 250;
                let outerCircleRadius = 248;

                let groupTicks = svgSpinner.append("g").attr( "id", "Ticks");
                let groupTicksRed = svgSpinner.append("g").attr( "id", "TicksRed");

                let chairOriginX = originX + ((outerCircleRadius) * Math.sin(0));
                let chairOriginY = originY - ((outerCircleRadius) * Math.cos(0));

                let chairWidth = 4;
                let chairsLength = this.length;

                // add gray tickets
                for (let i=0; i<chairsLength; i++) {

                    let chair = groupTicks.append("rect")
                        .attr("x", chairOriginX - (chairWidth / 2))
                        .attr("y", chairOriginY - (chairWidth / 2))
                        .attr("width",2)
                        .attr("height",13)
                        .style("fill", "#D6D6D6")
                        .style("stroke", "none");

                    chair.attr("transform", "rotate("+(i*360/chairsLength)+", 250, 250)");
                }

                // add red tickers
                for (let i=0; i<chairsLength; i++) {

                    let chair = groupTicksRed.append("rect")
                        .attr("x", chairOriginX - (chairWidth / 2))
                        .attr("y", chairOriginY - (chairWidth / 2))
                        .attr("width",4)
                        .attr("height",15)
                        .attr("opacity",0)
                        .style("fill", "#E4030B")
                        .style("stroke", "none");

                    chair.attr("transform", "rotate("+(i*360/chairsLength)+", 250, 250)");
                }

            },

            createTimeLine(){

                this.tlTicksUnsed = new TimelineMax({pause: true});
                this.tlTicksUnsed.staggerFromTo(this.ticksRed.querySelectorAll('rect'), .01, {autoAlpha:0}, {autoAlpha: 1, ease: Power2.easeInOut}, 1/120);
                this.tlTicksUnsed.stop(0)

                this.tl = new TimelineMax({delay: .3, onComplete: this.animateCompleteHandler});
                this.tl.seek(0).invalidate().stop(0);

                TweenMax.set(this.spinnerLineThin, {strokeDasharray: this.spinnerLineThin.getTotalLength(), rotation: -90, transformOrigin:"center center", smoothOrigin:true});
                TweenMax.set(this.spinnerLineBold, {strokeDasharray: this.spinnerLineBold.getTotalLength(), rotation: -90, transformOrigin:"center center", smoothOrigin:true});

                this.tl.fromTo(this.spinnerLineThin, 1.35, {strokeDashoffset: this.spinnerLineThin.getTotalLength(), rotation: -180}, { strokeDashoffset:0, rotation: -90, ease: Power3.easeInOut});
                this.tl.fromTo(this.spinnerLineBold, 1.35, {strokeDashoffset: this.spinnerLineBold.getTotalLength(), rotation: -180}, { strokeDashoffset:0, rotation: -90, ease: Power3.easeOut}, '-=0.75');
                this.tl.staggerFrom(this.ticks.querySelectorAll('rect'), .35, {autoAlpha: 0, ease: Power3.easeInOut}, .0075, '-=1.15');

                this.tl.from(this.ProgressContent, 2, {autoAlpha:0, ease: Power2.easeOut }, '-=.75');

                this.tl.timeScale(.75);

            },

            playAnimate(){
                if(this.animated == true) return;
                //
                this.restartAnimate();
                this.animated = true;
            },

            restartAnimate(){
                this.tl.restart();
                this.percentageObj.value = 0;
                setTimeout(()=>{
                    this.setPercent(this.parsePercentage);
                }, 2100)
            }

        },
        mounted(){

            this.createsTicks();
            //
            this.init();
            this.createTimeLine();
            //
            if(this.pause == false){
                this.playAnimate();
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "src/assets/fonts/Corbert/variables";

    .circle-progress {
        position: relative;
        margin-bottom: 2rem;
        .progress-wrapper {
            position: absolute;
            top: calc(50%);
            left: calc(50%);
            transform: translate(-50%, -50%);
        }
    }
    .progress-content {
        transform : translate(200,80);
        .percentage {
            font-size: 96px;
            font-family: $corbert-font-family-bold;
            letter-spacing: -.3rem;
            line-height: 1;
            /*color: red;*/
            /*fill: currentColor;*/
            margin-bottom: 0;
        }
        .label {
            font-size: 24px;
            font-family: $corbert-font-family-extrabold;
            max-width: 160px;
            word-wrap: normal;
        }
        .line {

        }
    }
    #Spinner {
        display: block;
        margin: 0 auto;
    }
</style>
